import React, { useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import Swal from "sweetalert2";
import axios from 'axios';

import AuthContext from '../context/auth-context';

import Card from '../components/UI/Card';

import useInput from '../hooks/useInput';

import logo from '../assets/logoufm1.png';

const Login = () => {
    
    const navigate = useNavigate();
    const authContext = useContext(AuthContext);

    // INPUT EMAIL
    // const emailValidacion = value => value.length > 8 && value.substring(value.length-8,value.length) === "@ufm.edu" && value.trim() !== "";
    const emailValidacion = value => value.trim() !== "" && value.includes("@") && value.length > 5;
    const {
        value: email,
        isValid: emailIsValid,
        isTouched: emailIsTouched,
        valueChangeHandler: emailChangeHanlder,
        inputBlurHandler: emailBlurHandler,
        resetInput: resetInputEmail
    } = useInput(emailValidacion);

    // INPUT PASSWORD
    const passwordValidacion = value => value.trim() !== "" && value.length > 3;
    const {
        value: password,
        isValid: passwordIsValid,
        isTouched: passwordIsTouched,
        valueChangeHandler: passwordChangeHanlder,
        inputBlurHandler: passwordBlurHandler,
        resetInput: resetInputPassword
    } = useInput(passwordValidacion);

    let formIsValid = false;

    if(emailIsValid && passwordIsValid){
        formIsValid = true;
    }

    const formSubmitHandler = async (event) => {
        event.preventDefault();

        // Validacion visual inputs
        emailBlurHandler();
        passwordBlurHandler();

        if(!formIsValid) return;

        //SHOW LOADING

        const form_data = new FormData();
        form_data.append('userEmail', email);
        form_data.append('userPassword', password);
        form_data.append('loginUsuario', 1);

        axios.post(process.env.REACT_APP_API_URL, form_data)
            .then(res => {

                const result = res.data;

                if( result.STATUS && result.STATUS === 'SUCCESS' && result.TOKEN_ID && result.NOMBRE && result.NOMBRE.trim() !== ""){

                    // LOGIN DE USUARIO
                    const expiresIn = 3600; // segundos
                    const expirationTime = new Date(new Date().getTime() + (expiresIn * 1000));
                    authContext.login(result.TOKEN_ID, expirationTime.toISOString());

                    Swal.fire({
                        icon: 'success',
                        title: '¡Hola ' + result.NOMBRE.trim() + '!',
                        showConfirmButton: false,
                        timer: 2000
                    });
                    navigate('/', { replace: true });

                } else if( result.STATUS && result.STATUS === 'ERROR' && result.ERROR && result.ERROR.ID && result.ERROR.MESSAGE ) {

                    if(result.ERROR.ID === "invalid-email" || result.ERROR.ID === "email-not-found"){
                        resetInputEmail();
                        resetInputPassword();
                    } else if(result.ERROR.ID === "incorrect-password"){
                        resetInputPassword();
                    }

                    Swal.fire({
                        icon: 'error',
                        titleText: "¡Error!",
                        text: result.ERROR.MESSAGE,
                        showConfirmButton: false,
                        showDenyButton: true,
                        denyButtonText: "Continuar",
                        backdrop: true,
                        allowOutsideClick: false
                    });

                } else {
                    Swal.fire({
                        icon: 'error',
                        titleText: "¡Error!",
                        text: "Ocurrió un error desconocido. Inténtelo de nuevo más tarde.",
                        showConfirmButton: false,
                        showDenyButton: true,
                        denyButtonText: "Aceptar",
                        backdrop: true,
                        allowOutsideClick: false
                    });

                    resetInputEmail();
                    resetInputPassword();
                }
                
            })
            .catch((error) => {
                Swal.fire({
                    icon: 'error',
                    title: 'Ocurrió un problema. Inténtelo más tarde.',
                    showConfirmButton: false,
                    timer: 3500
                });

                resetInputEmail();
                resetInputPassword();
            })
    };

    return (
        <div className="row">
            <div className="offset-md-4 col-md-4">
                <Card>
                    
                    <form className="row my-4" onSubmit={formSubmitHandler}>

                        <div className="col-md-12 text-center">
                            <img src={logo} alt="logo-ufm" style={{height: '5.5rem'}} />
                        </div>

                        <div className="col-md-10 offset-md-1"><hr /></div>

                        {/* EMAIL */}
                        <div className="col-md-8 offset-md-2 mb-3 mt-1">
                            <label className="form-label text-black-50" style={{userSelect: "none"}}>Correo electrónico</label>
                            <input 
                                type="email" 
                                name="email"
                                className={`form-control form-control-sm shadow-sm ${emailIsTouched ? ((emailIsValid) ? 'is-valid' : 'is-invalid') : ''}`}
                                value={email}
                                onChange={emailChangeHanlder}
                                onBlur={emailBlurHandler}
                            />
                            <div className="invalid-feedback" style={{userSelect: 'none'}}>
                                Debe ingresar su correo electrónico
                            </div>
                        </div>

                        {/* PASSWORD */}
                        <div className="col-md-8 offset-md-2 mb-3">
                            <label className="form-label text-black-50" style={{userSelect: "none"}}>Contraseña</label>
                            <input 
                                type="password" 
                                name="password"
                                className={`form-control form-control-sm shadow-sm ${passwordIsTouched ? ((passwordIsValid) ? 'is-valid' : 'is-invalid') : ''}`}
                                value={password}
                                onChange={passwordChangeHanlder}
                                onBlur={passwordBlurHandler}
                            />
                            <div className="form-text">
                                <Link to={"/recuperacion-password"} className="link-dark text-dark text-opacity-50 text-decoration-none" >¿Olvidó su contraseña?</Link>
                            </div>
                            <div className="invalid-feedback" style={{userSelect: 'none'}}>
                                Debe ingresar su contraseña
                            </div>
                        </div>

                        {/* BUTTONS */}
                        <div className="col-md-8 offset-md-2 my-3 text-center">
                            <button
                                className={`btn btn-danger`}>
                                <span style={{display: 'flex'}}>
                                    Iniciar sesión
                                </span>
                            </button>
                        </div>

                    </form>

                </Card>
            </div>

            <div className="offset-md-4 col-md-4 mt-2">
                <Card style={{ borderRadius: '0.375rem' }} >
                    <div className="col-md-10 offset-md-1 my-3" style={{ userSelect: 'none' }}>
                        ¿No tiene una cuenta? <Link to={"/registro"} className="link-dark" >Crear cuenta</Link>
                    </div>
                </Card>
            </div>

        </div>
    );
};

export default Login;